import { ProspectsSdk } from './prospects/prospects.sdk';
import { TargetSearchesSdk } from './prospects/targetSearches.sdk';
import { UserSdk } from './users/user.sdk';
import { UserAdminSdk } from './users/user-admin.sdk';
// import { AuthenticationSdk } from './users/authentication.sdk';
import { userOrganizationSdk } from './users/user-organizations.sdk';
import { SourcesSdk } from './prospects/sources.sdk';
import { RootSdk } from './root.sdk';
import { SearchSdk } from './prospects/search.sdk';
import { UserContactsSdk } from './user-contacts/user-contacts.sdk';
import { ProspectCollectionsSdk } from './prospects/prospect-collections.sdk';
import { IPublicClientApplication } from '@azure/msal-browser';

export class ProfilesSdk {
    user: UserSdk;
    userAdmin: UserAdminSdk;
    prospects: ProspectsSdk;
    targetSearches: TargetSearchesSdk;
    // // authentication: AuthenticationSdk;
    userOrganization: userOrganizationSdk;
    sources: SourcesSdk;
    root: RootSdk;
    search: SearchSdk;
    userContacts: UserContactsSdk;
    prospectCollections: ProspectCollectionsSdk;

    constructor(apiEndpoint: string, authProvider?: IPublicClientApplication) {
        this.user = new UserSdk(apiEndpoint, authProvider);
        this.userAdmin = new UserAdminSdk(apiEndpoint, authProvider);
        this.prospects = new ProspectsSdk(apiEndpoint, authProvider);
        this.targetSearches = new TargetSearchesSdk(apiEndpoint, authProvider);
        // // this.authentication = new AuthenticationSdk(apiEndpoint, authProvider);
        this.userOrganization = new userOrganizationSdk(apiEndpoint, authProvider);
        this.sources = new SourcesSdk(apiEndpoint, authProvider);
        this.root = new RootSdk(apiEndpoint, authProvider);
        this.search = new SearchSdk(apiEndpoint, authProvider);
        this.userContacts = new UserContactsSdk(apiEndpoint, authProvider);
        this.prospectCollections = new ProspectCollectionsSdk(apiEndpoint, authProvider);
    }
}
